/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The UpdateCompanyResponse model module.
* @module model/UpdateCompanyResponse
* @version 2020-12-7
*/
export default class UpdateCompanyResponse {
    /**
    * Constructs a new <code>UpdateCompanyResponse</code>.
    * 会社更新レスポンス
    * @alias module:model/UpdateCompanyResponse
    * @class
    * @param updatedAt {Number} 更新時刻
    * @param result {module:model/UpdateCompanyResponse.ResultEnum} 
    */

    constructor(updatedAt, result) {
        
        
        this['updatedAt'] = updatedAt;
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>UpdateCompanyResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/UpdateCompanyResponse} obj Optional instance to populate.
    * @return {module:model/UpdateCompanyResponse} The populated <code>UpdateCompanyResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UpdateCompanyResponse();
                        
            
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Number');
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
        }
        return obj;
    }

    /**
    * 更新時刻
    * @member {Number} updatedAt
    */
    'updatedAt' = undefined;
    /**
    * @member {module:model/UpdateCompanyResponse.ResultEnum} result
    */
    'result' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
